// Function to check if a value is valid (not null, undefined, or empty string)
export const hasValue = (value) => value !== null && value !== undefined && value !== '';

// Function to display a value or a placeholder if the value is invalid
export const displayValue = (value) => (hasValue(value) ? value : '--');

// Function to display a value with a unit or a placeholder if the value is invalid
export const displayValueWithUnit = (value, unit) => (hasValue(value) ? `${value}${unit}` : '--');